// Theme entry point.
//
// Boot order matters: public path first (so lazy chunks resolve), then
// smooth scrolling, then persistent components (header/nav/modals —
// outside the Barba container, mounted once), then Barba — whose `once`
// hook mounts the initial page's blocks.
import './public-path';
import { initScroll } from './core/scroll';
import { mountComponents } from './core/components';
import { initTransitions } from './core/transitions';

initScroll();
mountComponents();
initTransitions();
